<template>
    <div class="flex flex-col justify-between">
        <div
            v-tooltip.right="getTooltip()"
            class="mb-2 flex flex-col gap-1 border bg-white px-2 py-1 font-promedium"
            :class="{
                'cursor-pointer border-transparent hover:border-black-text':
                    (attrName.includes('MESTO') && store.mode !== 'mesto') ||
                    (!attrName.includes('MESTO') && store.mode !== 'struktura'),
                'cursor-pointer border-black-text hover:border-black-text':
                    (attrName.includes('MESTO') && store.mode === 'mesto') ||
                    (!attrName.includes('MESTO') && store.mode === 'struktura'),
                'cursor-default hover:border-transparent':
                    (!store.selectedLocality && !attrName.includes('MESTO')) ||
                    (!attrName.includes('MESTO') &&
                        store.selectedMetrika?.NAZEV_UDAJE_DATA === 'TYP_STR'),
            }"
            @click="HandleClick"
        >
            {{
                attrName.includes("MESTO")
                    ? $t("klok.ref_hodnoty_mesto")
                    : $t("klok.ref_hodnoty_struktura")
            }}
        </div>
        <div
            v-for="(item, index) in valueNames"
            :key="item"
            v-tooltip.left="
                item.includes('TYP')
                    ? useLocaleValue(store.selectedMetrika, tooltipAttrName)
                    : ''
            "
            class="flex flex-col gap-1 px-2 py-1"
        >
            <span class="font-proregular">{{
                toFirstLetterCapital(item)
            }}</span>
            {{
                useLocaleValue(store.selectedMetrika, attrName).split(",")
                    .length > 2 || index === 0
                    ? (toFirstLetterCapital(
                          item.toLowerCase().split("pro ")[1]
                      ) ??
                      toFirstLetterCapital(
                          item.toLowerCase().split("for the ")[1]
                      ))
                    : ""
            }}
            {{ getRefHodnota(index) }}
        </div>
    </div>
</template>

<script lang="ts" setup>
const { locale, t } = useI18n()
const store = useKlokStore()
const { getValue: getDictionaryValue } = useKlokDictionaries()

const props = defineProps<{
    attrName: keyof KlokMetrikaItem
    tooltipAttrName: keyof KlokMetrikaItem
}>()

const valueNames = computed(() => {
    if (!store.selectedMetrika) return []
    return useLocaleValue(store.selectedMetrika, props.attrName)
        .split(",")
        .slice(1)
})

function getRefHodnota(index: number) {
    if (!props.attrName.includes("MESTO") && !store.selectedLocality) return "—"
    const hodnoty_count = (
        store.selectedMetrika?.[props.attrName] as string
    ).split(",").length as number
    const REF_HODNOTY_ENUM: Record<number, string> =
        hodnoty_count === 2
            ? {
                  0: "TYP",
              }
            : {
                  0: "MAX",
                  1: "TYP",
                  2: "MIN",
              }
    const struktura = !props.attrName.includes("MESTO")
        ? store.selectedLocality?.TYP_STR
        : ""
    const hasDesatinna = store.selectedMetrika?.DESETINNA_MISTA
    const refHodnotaRow = store.settings?.ref_hodnoty.find(el => {
        return (
            el.STRUKTURA_CISLO === struktura &&
            el["HODNOTA"] === REF_HODNOTY_ENUM[index]
        )
    })
    if (!refHodnotaRow) return "—"
    const value =
        refHodnotaRow[
            store.selectedMetrika?.NAZEV_UDAJE_DATA.split(",")[0] as string
        ]

    if (value === "") return "—"
    if (hodnoty_count === 2) {
        return getDictionaryValue(
            store.selectedMetrika?.NAZEV_UDAJE_DATA.split(",")[0] as string,
            value,
            locale.value as LanguageCode
        )
    }
    if (hasDesatinna) {
        return (
            value.toFixed(
                store.selectedMetrika?.DESETINNA_MISTA.split(",")[0]
            ) +
            " " +
            useLocaleValue(store.selectedMetrika, "JEDNOTKA_ZOBRAZ").split(
                ","
            )[0]
        )
    } else {
        return (
            value +
            " " +
            useLocaleValue(store.selectedMetrika, "JEDNOTKA_ZOBRAZ").split(
                ","
            )[0]
        )
    }
}

function getTooltip() {
    if (!store.selectedLocality && !props.attrName.includes("MESTO"))
        return t("klok.ref_hodnoty_tooltip_struktura")
    if (
        store.selectedLocality &&
        !props.attrName.includes("MESTO") &&
        store.mode === "mesto"
    )
        return t("klok.ref_hodnoty_tooltip_struktura_vybrana")
    if (props.attrName.includes("MESTO") && store.mode === "struktura")
        return t("klok.ref_hodnoty_tooltip_mesto")
    return ""
}

function HandleClick() {
    if (!store.selectedLocality) return
    if (props.attrName.includes("MESTO")) {
        store.mode = "mesto"
    } else {
        store.mode = "struktura"
    }
}
</script>

<style scoped></style>
